/**
 * ErrorCaptureWrapper — bridges Security Platform auth to Ops Center error reporting
 *
 * Place inside AuthProvider in App.tsx so user context is available.
 */

import { ErrorCaptureProvider } from './ErrorCaptureProvider';
import { ErrorBoundary } from './ErrorBoundary';
import { useAuth } from '../hooks/useAuth';
import type { ReactNode } from 'react';

const config = {
  apiBaseUrl: import.meta.env.VITE_OPS_CENTER_API_URL || 'https://api.theonestack.com',
  apiKey: import.meta.env.VITE_OPS_CENTER_API_KEY || '',
  platformId: 'security',
};

export default function ErrorCaptureWrapper({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  // Only activate error reporting when an API key is configured
  if (!config.apiKey) {
    return <ErrorBoundary config={config}>{children}</ErrorBoundary>;
  }

  return (
    <ErrorBoundary config={config}>
      <ErrorCaptureProvider
        config={config}
        user={user ? { email: user.email || '', name: user.name || '' } : undefined}
      >
        {children}
      </ErrorCaptureProvider>
    </ErrorBoundary>
  );
}
